import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

/**
 * Admin dog profile form. Asks the server whether the pending edit reprices the
 * subscription, then fills the Confirm Changes modal from that one response and
 * opens it; otherwise the form saves directly. A failed preview also saves
 * directly, since the server reprices on save either way.
 */
export default class extends Controller {
  static values = { previewUrl: String, modalId: String };

  /**
   * @param {MouseEvent} event click on the Update Dog Profile submit button
   */
  confirm(event) {
    const modalEl = document.getElementById(this.modalIdValue);
    if (!modalEl || !this.element.checkValidity()) return;

    event.preventDefault();
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    const body = new FormData(this.element);
    body.delete('_method');
    fetch(this.previewUrlValue, {
      method: 'POST',
      headers: { 'X-CSRF-Token': token, Accept: 'application/json' },
      body,
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data && data.interval_count) {
          this.application
            .getControllerForElementAndIdentifier(modalEl, 'plan-change-confirmation-modal')
            ?.applyPreview(data);
          Modal.getOrCreateInstance(modalEl).show();
        } else {
          this.element.submit();
        }
      })
      .catch(() => this.element.submit());
  }
}
